module.exports = __webpack_public_path__ + "static/img/M8.81ba1048.png";